/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Support_BodyInputs */

const en_premium_blocked_support_body = /** @type {(inputs: Premium_Blocked_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription is in a state we need to fix by hand before you can change it. Email support and we will sort it out.`)
};

const es_premium_blocked_support_body = /** @type {(inputs: Premium_Blocked_Support_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción está en un estado que debemos corregir a mano antes de que puedas cambiarla. Escribe a soporte y lo resolveremos.`)
};

/**
* | output |
* | --- |
* | "Your subscription is in a state we need to fix by hand before you can change it. Email support and we will sort it out." |
*
* @param {Premium_Blocked_Support_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_support_body = /** @type {((inputs?: Premium_Blocked_Support_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Support_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_support_body(inputs)
	return en_premium_blocked_support_body(inputs)
});